export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/778fa27463088e5025df404ddce84708.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-black/30" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full py-32 pt-40">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 rounded-full bg-teal-400 animate-pulse" />
            <span className="text-white/90 text-xs font-medium tracking-widest uppercase">iOS Development Experts</span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6">
            Modern Apps<br />
            <span className="text-teal-400">for iOS</span><br />
            Platform
          </h1>

          {/* Description */}
          <p className="text-white/70 text-lg md:text-xl leading-relaxed max-w-xl">
            DUMAG DOO is a team of experts developing modern applications for the iOS platform. Our products are designed to enhance user experience and improve the security of mobile devices.
          </p>


        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/40 text-lg" />
      </div>
    </section>
  );
}
